import { List, Stack, Text } from "@chakra-ui/react";
import { t } from "i18next";
import {
  hlaAttributeFiltersToString,
  isHlaAttributeFiltersEmpty,
  isScoreFiltersEmpty,
  scoreFilterToString,
} from "../../../../map/models/MapFilters";
import { HlaForecastAction } from "../../../../project/models/HlaForecastScenario";
import { useStores } from "../../../../shared/stores/RootStore";

interface Props {
  action: HlaForecastAction;
}
export const HlaForecastActionTooltip: React.FC<Props> = ({ action }) => {
  const { projectStore } = useStores();
  const { scoreFilters, attributeFilters } = action.filters;
  const scoreFiltersEmpty = isScoreFiltersEmpty(scoreFilters);
  const attributeFiltersEmpty = isHlaAttributeFiltersEmpty(attributeFilters);
  const allEmpty = scoreFiltersEmpty && attributeFiltersEmpty;

  return (
    <Stack p={2} minW="200px">
      <Text textAlign="center" fontSize={"sm"}>
        Changes
      </Text>

      {Object.entries(action.attributeChanges).map(([attributeName, value]) => {
        const [name, side] = attributeName.split(".");
        return (
          <Text fontSize={"xs"} key={attributeName}>
            {`${t(`shared:hlaAttribute.${name}`, {
              speedUnit: projectStore.speedUnitStr,
            })}${side ? ` (${side})` : ""} = ${value}`}
          </Text>
        );
      })}

      <Text textAlign="center" fontSize={"sm"}>
        Applied with filters
      </Text>

      {allEmpty && <Text fontSize="xs">None selected</Text>}

      {!scoreFiltersEmpty && (
        <List.Root fontSize="xs">
          {Object.entries(scoreFilters)
            .map(
              ([crashType, filter]) =>
                filter &&
                `${t(`sdk:score.key.${crashType}`)}: ${scoreFilterToString(
                  filter,
                )}`,
            )
            .map((item, i) => (
              <List.Item key={i}>{item}</List.Item>
            ))}
        </List.Root>
      )}

      {!attributeFiltersEmpty && (
        <List.Root fontSize="xs">
          {Object.entries(hlaAttributeFiltersToString(attributeFilters)).map(
            ([name, value], i) => (
              <List.Item key={i}>{`${t(`shared:hlaAttribute.${name}`, {
                speedUnit: projectStore.speedUnitStr,
              })}: ${value}`}</List.Item>
            ),
          )}
        </List.Root>
      )}
    </Stack>
  );
};
